import React, { useState } from "react";
import styles from "../dralucianafigueiredo/dralucianafigueiredo.module.scss";
import Background from "./src/background-links.png";
import LinkPersonalizado7 from "../../components/LinkPersonalizado7/linkPersonalizado7.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import CatalogIcon from "../../icons/catalogIcon.tsx";
import InfoIcon from "../../icons/infoIcon.tsx";

const Dralucianafigueiredo: React.FC = () => {
    return (
        <div className={styles.dralucianafigueiredo}>
            <div
                className={styles["body-thunder"]}
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className={styles["container-thunder"]}>
                    <h1 className="pt-2">Dra. Luciana Figueiredo</h1>
                    <p>CIRURGIÃ DENTISTA</p>

                    <div className={styles.links}>
                        <LinkPersonalizado7
                            topLeft
                            linkInterno
                            href="/dralucianafigueiredo/sobremim"
                            title="SOBRE MIM"
                            icon={<InfoIcon height="32" color="#5CC4D1" />}
                            colorText="#333333"
                        />
                        <LinkPersonalizado7
                            topRight
                            linkInterno
                            href="/dralucianafigueiredo/servicos"
                            title="SERVIÇOS"
                            icon={<CatalogIcon height="34" color="#5CC4D1" />}
                            colorText="#333333"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517996735601?text=Olá, gostaria de agendar um horário."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="34" color="#5CC4D1" />}
                            colorText="#333333"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/dNeAmvvQR4mmyDXF7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="34" color="#5CC4D1" />}
                            colorText="#333333"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/dra.luciana.figueiredo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="30" color="#5CC4D1" />}
                            colorText="#333333"
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Dralucianafigueiredo;
